import React, { useEffect } from "react";
import "@elastic/charts/dist/theme_light.css";
import { EuiPage, EuiPageBody, EuiPageContent } from "@elastic/eui";

import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import TopHeader from "../components/Header/Header";
import SearchTablePage from "../pages/reports/SearchTablePage";
import DataGridPage from "../pages/reports/DataGridPage";
import ChartPage from "../pages/reports/ChartPage";
import ExtractionPage from "../pages/manage/ExtractionPage";
import TemplatePage from "../pages/manage/TemplatePage";
import TaxesPage from "../pages/manage/TaxesPage";

import "./main.css";
import UploadInvoicePage from "../pages/manage/UploadInvoicePage";
import { LoginPage } from "../pages/home/LoginPage";
import { GlobalAlert } from "../features/alert/GlobalAlert";
import { GlobalLoading } from "../features/global_loading/GlobalLoading";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsLoggedIn,
  selectIsValidatingUser,
} from "../features/auth/auth.slice";
import {
  LoginUserRoute,
  PrivateRoute,
} from "../components/PrivateRoute/PrivateRoute";
import { loginWithAccessToken } from "../features/auth/auth.thunk";

const MainLayout = (props) => {
  const isValidatingUser = useSelector(selectIsValidatingUser);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const dispatch = useDispatch();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    dispatch(loginWithAccessToken(accessToken));
  }, []);

  return (
    <>
      {isLoggedIn && <TopHeader />}

      <EuiPage paddingSize="none" className="container mt-1">
        <EuiPageBody paddingSize="l">
          <EuiPageContent
            verticalPosition="center"
            horizontalPosition="center"
            className="w-full"
            // paddingSize="none"
            style={{
              background: "transparent",
              border: "0px",
              boxShadow: "none",
            }}
          >
            {!isValidatingUser && (
              <Switch>
                <PrivateRoute
                  path="/reports/search-table"
                  component={SearchTablePage}
                />
                <PrivateRoute
                  path="/reports/data-grid"
                  component={DataGridPage}
                />
                <PrivateRoute path="/reports/charts" component={ChartPage} />
                <PrivateRoute
                  path="/manage/upload"
                  component={UploadInvoicePage}
                />
                <PrivateRoute
                  path="/manage/extraction"
                  component={ExtractionPage}
                />
                <PrivateRoute
                  path="/manage/template"
                  component={TemplatePage}
                />
                <PrivateRoute path="/manage/taxes" component={TaxesPage} />
                <LoginUserRoute path="/auth/login" component={LoginPage} />
                <Redirect to="/reports/search-table" />
              </Switch>
            )}
            <GlobalAlert />
            <GlobalLoading />
          </EuiPageContent>
        </EuiPageBody>
      </EuiPage>
    </>
  );
};

export default MainLayout;
